module.exports = __webpack_public_path__ + "img/37836532000254.053d2766.png";